import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

export const ReviewSectionTitle = ({ icon, children }: { icon: ReactNode; children: ReactNode }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mb: 1.25 }}>
    <Box sx={{ color: "primary.main", display: "flex", "& svg": { fontSize: 16 } }}>{icon}</Box>
    <Typography sx={{ fontSize: "0.67rem", fontWeight: 800, letterSpacing: "0.09em", textTransform: "uppercase" }}>
      {children}
    </Typography>
  </Box>
);
